import React, { useContext } from "react";
import { LoginContext } from "./Auth/LoginContextProvider";

const PrivateDiv = (props) => {
  const { loginToken } = useContext(LoginContext);
  return (
    <div>
      {loginToken !== null && <div {...props}></div>}
    </div>
  );
};

export default PrivateDiv;
